import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import Field from '@/packages/field';
import { checkEmail } from '@/shared/utils/validator';
import { InfoComplementField } from '../../types';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'CommonEmail' })
export default class CommonEmail extends Vue implements InfoComplementField {
  @Prop({ default: '' })
  private value!: string;

  /** 校验器  调用onValidator方法时会优先调用传入的校验器
   * (value, setErrorMsg) => boolean; value为当前输入框输入的值 setErrorMsg是一个设置校验错误信息的函数
  */
  @Prop()
  private validator: ((value: string, setErrorMsg: (msg: string) => void) => boolean) | undefined;

  private commonEmail = '';

  private errorMsg = '';

  private setErrorMsg(msg: string) {
    this.errorMsg = msg;
  }

  // 邮箱
  public onValidator(): boolean {
    const val = this.commonEmail;
    if (typeof this.validator === 'function') {
      return this.validator(val, this.setErrorMsg.bind(this));
    }

    if (!checkEmail(val)) {
      this.errorMsg = '请输入正确的邮箱';
      return false;
    }
    return true;
  }

  private created() {
    if (this.value) {
      this.commonEmail = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: string) {
    if (val !== this.commonEmail) {
      this.commonEmail = val;
    }
  }

  private onChangeEmail(val: string) {
    this.errorMsg = '';
    this.$emit('change', val);
  }

  private onBlur() {
    this.onValidator();
    this.$emit('blur');
  }

  private render() {
    return (
      <div class={style.CommonEmail}>
        <Field
          v-model={this.commonEmail}
          label="电子邮箱"
          sub={true}
          placeholder="请输入邮箱"
          onChange={this.onChangeEmail.bind(this)}
          error={this.errorMsg}
          maxlength={64}
          type="text"
          onBlur={this.onBlur.bind(this)}
        />
      </div>
    );
  }
}
